import store from "../store";
import Constants from "../config/constants";
import { serviceGetPreferredPartners } from "../services/PreferredPartner.service";
import EventEmitter from "../libs/Events.utils";

export const FETCH_INIT = "FETCH_INIT_PREFERRED_PARTNER";
export const FETCHED = "FETCHED_PREFERRED_PARTNER";
export const FETCHED_FAIL = "FETCHED_FAIL_PREFERRED_PARTNER";
export const FETCHED_FILTER = "FETCHED_FILTER_PREFERRED_PARTNER";
export const FETCH_NEXT = "FETCH_NEXT_PREFERRED_PARTNER";
export const FILTER = "FILTER_PREFERRED_PARTNER";
export const RESET_FILTER = "RESET_FILTER_PREFERRED_PARTNER";
export const SET_SORTING = "SET_SORTING_PREFERRED_PARTNER";
export const SET_FILTER = "SET_FILTER_PREFERRED_PARTNER";
export const SET_PAGE = "SET_PAGE_PREFERRED_PARTNER";
export const CHANGE_PAGE = "CHANGE_PAGE_PREFERRED_PARTNER";
export const CHANGE_STATUS = "CHANGE_STATE_PREFERRED_PARTNER";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_PREFERRED_PARTNER";
export const CREATE_DATA = "CREATE_PREFERRED_PARTNER";
export const UPDATE_DATA = "UPDATE_PREFERRED_PARTNER";
export const DELETE_ITEM = "DELETE_PREFERRED_PARTNER";

export function actionFetchPreferredPartner(
  index = 1,
  sorting = {},
  filter = {}
) {
  const request = serviceGetPreferredPartners({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionChangePagePreferredPartner(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function actionFilterPreferredPartner(value) {
  const request = null;
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null }); 
    });
  };
}
export function actionResetFilterPreferredPartner() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}

export function actionSetPagePreferredPartner(page) {
  const stateData = store.getState().pref_partner;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchPreferredPartner(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  console.log(currentPage, totalLength);
  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
